import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class DemoRegistrationFormService {

  constructor(
    private http: HttpClient,
    private occService: OccEndpointsService
  ) { }


  getDemoBreadcrumb() {
    return this.http.get(this.occService.buildUrl(`mydemo/demoRegistration`));
  }
  getFormBreadcrumb() {
    return this.http.get(this.occService.buildUrl(`mydemo/demoRegistrationForm`));
  }
}


